module.exports = __webpack_public_path__ + "static/media/Samples_Logo.1677fd4b.svg";